import { BID_PRICE } from '../../../../Tiktok/LineItemForms/LineItemTikTokCreate/LineItemTikTokCreateForm/fields'
import { BUDGET } from '../../../../Tiktok/LineItemForms/LineItemTikTokEdit/fields'

export const formatValuesToFE = values => {
  return {
    [BUDGET]: values[BUDGET] || '',
    [BID_PRICE]: values.bid || ''
  }
}
